export default () =>{
(function(){
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.body;

    var heightHeader = document.getElementById('header').offsetHeight;

    var checkScroll = function() {

        /*
        ** Find the direction of scroll
        ** 0 - initial, 1 - up, 2 - down
        */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
        }
        else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
        }

        if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
        }

        if(curScroll === 0 ) {
        header.classList.remove('sticky-hide');
        header.classList.remove('sticky-open');
        header.classList.remove('sticky');
        }

        prevScroll = curScroll;
    };

    var toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > heightHeader && curScroll < heightHeader + 100) {
          header.classList.add('sticky');
          setTimeout(() => {
            header.classList.add('sticky-hide');
          }, 10);
          header.classList.remove('sticky-open');
          prevDirection = direction;
        }
        else if (direction === 2 && curScroll > heightHeader + 101) {
          // prevDirection = direction;
          header.classList.add('sticky-hide');
          header.classList.remove('sticky-open');
          header.classList.remove('sticky');
          prevDirection = direction;
        }
        else if (direction === 1) {
        header.classList.remove('sticky-hide');
        header.classList.add('sticky-open');
        header.classList.remove('sticky');
        prevDirection = direction;
        }
    };

    window.addEventListener('scroll', checkScroll);


    })();

  // dropdown
  const ddHeader = document.querySelector('.header');
  const ddItems = document.querySelectorAll('.header .menu__item');



  let mediaQuery = window.matchMedia('(max-width: 1024px)')

  // handlers
  const clikHandler = (e) => {
    const item = e.currentTarget.parentNode;
    if (!item.classList.contains("_active")) {
      const ddItemsActive = document.querySelectorAll(".menu__item._active")
      ddItemsActive.forEach(itemAccordionActive => {
        itemAccordionActive.classList.remove("_active")
      })

      item.classList.add("_active")
      ddHeader.classList.add("opened--dd")

    } else {
      item.classList.remove("_active")
      ddHeader.classList.remove("opened--dd")
    }
  }

  const mouseEnterHandler = (e) => {
    e.currentTarget.parentNode.classList.add("_active")
    ddHeader.classList.add("opened--dd")
  }

  const mouseLeaveHandler = (e) => {
    e.currentTarget.classList.remove('_active')
    ddHeader.classList.remove("opened--dd")
  }

  function handleDeskChange(e) {
    ddItems.forEach(itemAccordion => {
      const ddBtn = itemAccordion.querySelector(".menu__link")


      ddBtn.addEventListener("click", clikHandler)


    })
  }

  handleDeskChange()

  // click off elem
  document.addEventListener("click", (e) => {
    let target = e.target;

    if (ddHeader.contains(target)) {} else {
      ddHeader.classList.remove('opened--dd');
      const ddListActive = document.querySelectorAll(".header .menu__item._active")
      ddListActive.forEach(itemDdActive => {
          itemDdActive.classList.remove("_active")
      })
    }
  })


  // hover click icons header info
  const headInfo = document.querySelector('.header__info');
  const btnLang = document.querySelector('.head-lang__open');
  const btnSearch = document.querySelector('.search-form__open');
  const inputSearch = document.querySelector('.search-form__open');

  function getClickedSearch () {
    headInfo.classList.add('_active');
    document.body.classList.add('head-mob-icons-open');
    this.parentElement.classList.add('_current');
    btnLang.parentElement.classList.remove('_current');
  }

  function getClickedLang () {
    headInfo.classList.add('_active');
    document.body.classList.add('head-mob-icons-open');
    this.parentElement.classList.add('_current');
    btnSearch.parentElement.classList.remove('_current');
  }

  function offClickedEnd () {
      setTimeout(() => {
        this.classList.remove('_active');
        document.body.classList.remove('head-mob-icons-open');
        btnSearch.parentElement.classList.remove('_current');
        btnLang.parentElement.classList.remove('_current');
      }, 10);
  }

  btnLang.addEventListener('click', getClickedLang);
  // btnLang.addEventListener('mouseout', offClicked);

  btnSearch.addEventListener('click', getClickedSearch);
  // btnSearch.addEventListener('mouseleave', offClicked);

  headInfo.addEventListener('mouseleave', offClickedEnd);


  let burgerLink = document.querySelectorAll(".burger");

  burgerLink.forEach(function (item) {
    item.addEventListener(
      "click",
      function (e) {
          if (document.body.classList.contains("head-mob-icons-open")) {
            document.body.classList.remove("head-mob-icons-open")
            // document.body.classList.add("menu-open");
          } else {
            document.body.classList.toggle("menu-open");
          }
      },
      false
    );
  });


    // active element header item menu
    const menuItemHeader = document.querySelectorAll('.menu__item');
    menuItemHeader.forEach(e => {
        const menuItemInner = e.querySelectorAll('.menu-dd__item');
        menuItemInner.forEach(eInner => {
            const menuItemInnerLink = eInner.querySelector('.menu-dd__link');
            if(menuItemInnerLink.getAttribute('href') === window.location.href) {
                e.classList.add('menu__item_active')
            }
        });
    });

};
